/**
 * Facility Position model matching backend FacilityPositionDto
 */
export interface FacilityPosition {
  id: number;
  facilityId: string;
  name: string;
  abbreviation: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
}

/**
 * Nested position object returned in admin/role responses
 * Uses Pick to extract only the fields included in nested responses
 */
export type FacilityPositionNested = Pick<
  FacilityPosition,
  'id' | 'name' | 'abbreviation'
>;
